<template>
  <div class="container">
    <div class="nav-tab">
      <div style="display: flex">
        <img src="../../../../assets/images/arrow.png" class="ims" alt="" />
        <div>您的当前位置是：首页-廉政消防</div>
      </div>
      <div
        class="hover-underline"
        style="display: flex; margin-right: 56px"
        @click="returnshow"
      >
        <div style="display: inline-block">
          <img src="../../../../assets/images/return.png" class="imgs" alt="" />
        </div>
        返回
      </div>
    </div>
    <div class="content">
      <div class="title">图片新闻</div>
      <div class="line"></div>
      <div class="info">
        <span style="margin-right: 7px">出处：{{ from }}</span
        ><span>时间：{{ date }}</span>
      </div>
      <div class="browse">
        <!-- <div class="count">
          浏览次数：<span style="font-size: 20px; color: #2e5bb6">{{
            count
          }}</span>
        </div> -->
      </div>
      <div class="img-box">
        <img
          v-for="item in swirperList"
          :src="item.annexUrl"
          :key="item.id"
          alt=""
        />
      </div>
    </div>
    <div class="bottom-info">
      <div class="bottom-box">
        <div>Copyright © 池州消防支队 allright reserved</div>
        <div>【后台管理】</div>
        
      </div>
    </div>
  </div>
</template>

<script>
import { listAll } from "@/api/index";
export default {
  data() {
    return {
      count: 10,
      from: "池州支队网",
      date: "2024-10-08",
      swirperList: [],
      searchFrom: {
        pageNum: 1,
        pageSize: 10,
        status:4,
      },
    };
  },
  mounted() {
    this.getlistAll();
  },
  methods: {
    getlistAll() {
      listAll(this.searchFrom).then((res) => {
        this.swirperList = res.data.data.list.filter((item) => {
          return item.messageType === 14; // 只返回 messageType 为 0 的项
        });
      });
    },
    returnshow() {
      this.$emit("setCilck");
    },
  },
};
</script>

<style scoped lang="scss">
#map {
  width: 100%;
  height: 398px;
}

.container {
  width: 100%;
  background: #f0f5ff;
}

.nav-tab {
  width: 60%;
  height: 48px;
  background: #f5f5f5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;

  .ims {
    width: 23px;
    height: 20px;
    margin-left: 40px;
  }
  .imgs {
    width: 16px;
    margin: 0;
    height: 14px;
    vertical-align: middle;
    margin-right: 8px;
  }
  div {
    font-size: 16px;
    color: #2b56ac;
    margin-left: 16px;
  }
}
.hover-underline {
  cursor: pointer; /* 鼠标悬停时显示手形光标 */
}

.hover-underline:hover {
  text-decoration: underline; /* 悬停时添加下划线 */
}

.content {
  width: 1120px;
  margin: 0 auto;
  margin-top: 40px;

  .title {
    text-align: center;
    font-weight: bold;
    font-size: 24px;
    color: #333333;
    margin-bottom: 16px;
  }
  .line {
    width: 1040px;
    height: 2px;
    margin: 0 auto;
    margin-bottom: 16px;
    background: #2e5bb6;
  }

  .info {
    text-align: center;
  }

  .browse {
    width: 1040px;
    height: 40px;
    margin: 0 auto;
    font-size: 14px;
    color: #333333;
    position: relative;

    .count {
      position: absolute;
      right: 0;
    }
  }
  .img-box {
    width: 1040px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    img {
      width: 510px;
      height: 340px;
    }
  }
}

.bottom-info {
  width: 1120px;
  height: 100px;
  background: #0e67ab;
  color: #fff;
  font-size: 14px;
  margin: 0 auto;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;

  .bottom-box div {
    margin: 6px 0;
    text-align: center;
  }
}
</style>
